import React, { useEffect, Fragment, useRef } from 'react';
import "./MultipleSelectDropDown.scss";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
 

const useStyles = makeStyles({
  dropdownUserStyle:
  {
    top: '51% !important',
    position: 'absolute',

  },
  dropdownRoleStyle:
  {
    top: '54% !important',
    position: 'absolute',

  },
});


function getStyles(name: any, personName: any[], theme: Theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const MultipleSelectComponent = (props: MultipleSelectProps) => {
  const theme = useTheme();
  const [name, setName] = React.useState<string[]>([]);
  const classes = useStyles();

  // Props Drilling
  const {
    data,
    from,
    handleScopes,
    handleRoles,
    handleRoleList,
    mode,
    selectedValues
  } = props;

  const handleChange = (event: React.ChangeEvent<{ value: any }>) => {
    setName(event.target.value as string[])

  };

  const handleScopesRef = useRef(handleScopes);
  const handleRolesRef = useRef(handleRoles);
  const handleRoleListRef = useRef(handleRoleList);
  handleScopesRef.current = handleScopes;
  handleRolesRef.current = handleRoles;
  handleRoleListRef.current = handleRoleList;

  useEffect(() => {
    if (name && from === 'ROLE') {
      handleScopesRef.current?.(name);
    }
    else if (name && from !== 'ROLE' && from !=='RoleList') {
      handleRolesRef.current?.(
        name.map((item: any) =>
          data.find((d: any) => (d.roleName ?? d.RoleName) === item)
        )
      );
    }
    else if (from === 'RoleList') {
      handleRoleListRef.current?.(
        name.map((item: any) => data.find(currentData => currentData.userName === item))
      );
    }
  }, [data, from, name]);


  useEffect(() => {
    const list = Array.isArray(selectedValues) ? selectedValues : [];
    if (from === 'ROLE' && mode !== 'add') {
      setName(list);
    }
    else if (from === 'USER' && mode !== 'add') {
      setName(
        list.map((currentEntity: any) => currentEntity?.roleName ?? currentEntity?.RoleName).filter(Boolean)
      );
    }
  }, [from, mode, selectedValues]);


  return (
    <div className="Role-multi-select">
      <FormControl disabled={props.mode === 'view'}>
        <Select
          labelId="demo-mutiple-chip-label"
          id="demo-mutiple-chip"
          multiple
          value={name}
          onChange={handleChange}
          style={{width:"85%"}}
          input={<Input id="select-multiple-chip" />}
          renderValue={selected => (
            <span className="Role-multi-chip">
              {props.from === 'ROLE' && (selected as string[]).map((value, index) => (
                <Fragment key={index}>
                  {props && props.mode === 'view' && <Chip label={value} />}
                  {props && props.mode !== 'view' && <Chip key={value} label={value} onDelete={handleChange} color="primary" />}
                </Fragment>
              ))}
              {props.from !== 'ROLE' && (selected as string[]).map((value: any, index) => (
                <Fragment key={index}>
                  <Chip key={value.id} label={value} onDelete={handleChange} color="primary" />
                </Fragment>
              ))}
            </span>
          )}
          MenuProps={{ classes: { paper: props.from === 'ROLE' ? classes.dropdownRoleStyle : classes.dropdownUserStyle } }}

        >
          {
            props.from === 'ROLE' &&
            props.data.map((item, index) =>
              <MenuItem className="roleOptions" key={index} value={item} style={getStyles(item, name, theme)}>
                <Checkbox className="rolecheck" checked={name.indexOf(item) > -1} color="primary" />
                <ListItemText className="rolechecktext" primary={item} />
              </MenuItem>
            )
          }
          {
            props.from !== 'ROLE' &&  props.from !== 'RoleList' &&
            props.data.map((d: any) => d.roleName ?? d.RoleName).map((item, index) =>
              <MenuItem className="roleOptions" key={index} value={item} style={getStyles(item, name, theme)}>
                <Checkbox className="rolecheck" checked={name.indexOf(item) > -1} color="primary" />
                <ListItemText className="rolechecktext" primary={item} />
              </MenuItem>
            )
          }
          {
            props.from === 'RoleList' &&
            props.data.map(d => d.userName).map((item, index) =>
              <MenuItem className="roleOptions" key={index} value={item} style={getStyles(item, name, theme)}>
                <Checkbox className="rolecheck" checked={name.indexOf(item) > -1} color="primary" />
                <ListItemText className="rolechecktext" primary={item} />
              </MenuItem>
            )
          }

        </Select>
      </FormControl>
    </div>
  );
}

export default MultipleSelectComponent;

interface MultipleSelectProps {
  data: any;
  labelname: any;
  mode?: string;
  selectedValues?: any;
  handleScopes?: any;
  handleRoles?: any;
  handleRoleList?: any;
  from: string;
}
